export default {
  isReady(state, getters, rootState, rootGetters) {
    return !!state.profile && !!state.roles && !!state.subjects && !!state.schoolSystems;
  },

  profileInfo(state, getters, rootState, rootGetters) {
    if (!state.profile) {
      return {};
    }
    let profile = state.profile;

    let roleId = profile.roles[0];
    let role = state.roles[roleId];

    let subjects = profile.metadata['科目'] || [];
    subjects = subjects.map(s => state.subjects[s] ? state.subjects[s].tname : '');
    let schoolSystemId = profile.metadata['學制'];
    let schoolSystem = state.schoolSystems[schoolSystemId];

    return {
      id: profile._id,
      avatar: profile.avatar,
      username: profile.username,
      nickname: profile.nickname,
      email: profile.email,
      role: role ? role.name : '',
      subjects: subjects,
      schoolSystemName: schoolSystem ? schoolSystem.tname : '',
      schoolSystemId: schoolSystemId,
      points: profile.metadata['家教點數'] || 0,
      grade: profile.metadata['年級'],
      gender: profile.metadata['性別'],
      parentMobilePhone: profile.metadata['家長行動電話'],
      schoolName: profile.metadata['schoolname'],
      schoolId: profile.metadata['學校']
    };
  },

  schoolSystemOptions(state, getters, rootState, rootGetters) {
    let result = [];
    let schoolSystems = state.schoolSystems || {};

    for (let key in schoolSystems) {
      if (!schoolSystems.hasOwnProperty(key)) {
        continue;
      }

      let schoolSystem = schoolSystems[key];
      // exclude 高職
      if (schoolSystem._id === '5a4378cc9a3a8503133ff103') {
        continue;
      }

      result.push({
        text: schoolSystem.tname,
        value: schoolSystem._id
      });
    }

    return result;
  },

  subjectOptions(state, getters, rootState, rootGetters) {
    let options = [];
    for (let key in state.subjects) {
      if (!state.subjects.hasOwnProperty(key)) {
        continue;
      }
      options.push({text: state.subjects[key].tname, value: key});
    }

    return options;
  },

  genderOptions(state, getters, rootState, rootGetters) {
    return [
      {text: '男', value: '男性'},
      {text: '女', value: '女性'}
    ];
  },

  gradeOptions(state, getters, rootState, rootGetters) {
    return [
      {text: '一年級', value: 1},
      {text: '二年級', value: 2},
      {text: '三年級', value: 3},
      {text: '四年級', value: 4},
      {text: '五年級', value: 5},
      {text: '六年級', value: 6},
      {text: '七年級', value: 7},
      {text: '八年級', value: 8},
      {text: '九年級', value: 9},
      {text: '十年級', value: 10},
      {text: '十一年級', value: 11},
      {text: '十二年級', value: 12}
    ];
  }
};
